import { DefaultTheme } from '../theme';

export const CSS = {
	container: 'c-SearchInput',
	icon: 'c-SearchInput__icon',
	input: 'c-SearchInput__input',
	clear: 'c-SearchInput__clear',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		width: '100%',
		height: '28px',
		'align-items': 'center',
		padding: `0 ${DefaultTheme.space(2)}`,
		'box-sizing': 'border-box',
		'background-color': DefaultTheme.background.lightGrey,
	},
	[CSS.input]: {
		flex: '1',
		outline: 'none',
		'font-family': DefaultTheme.font.family,
		'font-size': DefaultTheme.font.size,
		width: '100%',
		border: 'none',
		'padding-left': DefaultTheme.space(1),
		'margin-left': DefaultTheme.space(4),
		'background-color': 'transparent',
	},
	[`${CSS.input}::placeholder`]: {
		opacity: '0.6',
		transition: 'opacity 0.2s ease',
	},
	[`${CSS.input}:focus::placeholder`]: {
		opacity: '0.8',
	},
	[CSS.icon]: {
		'pointer-events': 'none',
	},
};
